import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BusyIndicator } from './'
import { Ptag } from './fonts'

const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: ${props => (props.bgColor ? props.bgColor : '#ffffff')};
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  z-index: ${props => (props.zindex ? props.zindex : 999)};
`

const OverlayLoader = props => {
  return (
    <Overlay bgColor={props.bgColor} zindex={props.zindex}>
      <BusyIndicator />
      {props.waitMessageText && <Ptag fontSize="14px">{props.waitMessageText}</Ptag>}
    </Overlay>
  )
}

export default OverlayLoader
